module.exports = __webpack_public_path__ + "img/Ident-Process-10.9bd3a6c5.png";